import React from "react";
import classNames from "classnames";
import { inject, observer } from "mobx-react";

import AdaptiveTooltip from "../../AdaptiveTooltip";
import { $const } from "../../../helper";
import "../stylesheets/collegeAvatars.scss";

@inject("languageStore")
@observer
class CollegeAvatars extends React.Component {
  render() {
    const lang = this.props.languageStore.lang;
    const info = this.props.info.slice(0, 5);
    const nums = info.length;
    const names = info.reduce((pre, cur) => {
      const { name, enName } = cur;
      const curName = lang === "zh" ? name || enName : enName || name;
      return pre ? `${pre}&${curName}` : curName;
    }, "");

    return (
      <div className="collegeAvatars">
        <div className={classNames("collegeAvatarsBox", `collegeAvatarsBox--${nums}`)}>
          {info.map((item, index) => {
            const { id, name, enName, schoolBadge } = item;
            const curName = lang === "zh" ? name || enName : enName || name;
            return (
              <img
                key={`${index}-${id}`}
                alt={curName}
                className={classNames(
                  "collegeAvatarsBox__itemBox",
                  `collegeAvatarsBox__item--${index + 1}`,
                  `collegeAvatarsBox__itemBox--${nums}`
                )}
                src={schoolBadge || $const.DEFAULT_AVATAR}
              ></img>
            );
          })}
        </div>
        <AdaptiveTooltip className="collegeAvatars__names" title={names}>
          {names}
        </AdaptiveTooltip>
      </div>
    );
  }
}

export default CollegeAvatars;



// WEBPACK FOOTER //
// ./src/components/common/teamInfo/collegeAvatars.js